'use client';

import { Box, Card, CardContent, Grid, Typography } from '@mui/material';

import { formatCompactNumber, formatCurrency } from '@/utils';

interface ProfileStatsRowsProps {
  positionsValue: number;
  biggestWin: number;
  predictions: number;
}

const StatCard = ({
  label,
  value,
  subValue,
}: {
  label: string;
  value: string;
  subValue?: string;
}) => {
  return (
    <Card
      sx={{
        bgcolor: 'background.paper',
        borderRadius: 4,
        border: '1px solid',
        borderColor: 'divider',
        height: '100%',
      }}
    >
      <CardContent sx={{ p: 3, '&:last-child': { pb: 3 } }}>
        <Typography
          variant="h4"
          fontWeight={700}
          sx={{ mb: 1, letterSpacing: '-0.02em', color: 'text.primary' }}
        >
          {value}
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary', fontWeight: 500 }}>
          {label}
        </Typography>
      </CardContent>
    </Card>
  );
};

const ProfileStatsRows = ({ positionsValue, biggestWin, predictions }: ProfileStatsRowsProps) => {
  return (
    <Grid container spacing={2} sx={{ mb: 4 }}>
      <Grid item xs={12} md={4}>
        <StatCard label="Positions Value" value={formatCurrency(positionsValue)} />
      </Grid>
      <Grid item xs={12} md={4}>
        <StatCard label="Biggest Win" value={`$${formatCompactNumber(biggestWin)}`} />
      </Grid>
      <Grid item xs={12} md={4}>
        <StatCard label="Predictions" value={predictions.toLocaleString()} />
      </Grid>
    </Grid>
  );
};

export default ProfileStatsRows;
